import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FollowUpsComponentsModule } from './components/follow-up-components.module';
import { FollowUpsService } from './follow-ups.service';

@NgModule({
  imports: [CommonModule, FollowUpsComponentsModule],
  exports: [FollowUpsComponentsModule],
  providers: [FollowUpsService],
})
export class NgFollowUpsModule {}
